import { makeStyles } from '@material-ui/core';

export const CustomBackdropStyle = makeStyles((theme) => ({
    root: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));
